import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

// Libs
import MicroModal from 'micromodal';
import { useTranslation } from 'next-i18next';

// Components
import Button from '../../atoms/Button/Button';

const Modal = dynamic(() => import('../../organisms/Modal/Modal'), {
  ssr: false,
});

function InfoModalButton({
  id, children, modalTitle, modalContent, className, styleWrapper, styleButton,
}) {
  const { t } = useTranslation();

  return id && children && modalContent ? (
    <div className={className} style={styleWrapper}>
      <button
        type="button"
        className="d-flex center cursor-pointer"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          MicroModal.show(id);
        }}
        style={styleButton}
      >
        {children}
      </button>

      <Modal
        id={id}
        title={modalTitle}
        maxWidth={550}
        actionButton={(
          <Button onClick={() => MicroModal.close(id)}>
            {t('common.close')}
          </Button>
        )}
        hideCancelButton
      >
        {modalContent}
      </Modal>
    </div>
  ) : null;
}

InfoModalButton.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  modalTitle: PropTypes.string,
  modalContent: PropTypes.node,
  className: PropTypes.string,
  styleWrapper: PropTypes.shape({}),
  styleButton: PropTypes.shape({}),
};

InfoModalButton.defaultProps = {
  children: null,
  modalTitle: null,
  modalContent: PropTypes.node,
  className: null,
  styleWrapper: null,
  styleButton: null,
};

export default InfoModalButton;
